<template>
  <div class="touch-none border-t border-light-bd-muted px-4 py-3">
    <div class="flex items-center gap-2">
      <div class="relative flex min-w-0 flex-1 items-center">
        <textarea
          ref="textareaRef"
          v-model="inputText"
          class="w-full resize-none rounded-lg border border-light-bd-default bg-white px-3 py-2 text-sm text-light-fg-default placeholder:text-light-fg-muted focus:border-light-fg-accent focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
          rows="1"
          :disabled="disabled"
          :maxlength="MAX_LENGTH"
          :placeholder="placeholder"
          @input="autoResize"
          @keydown.enter.exact.prevent="handleKeydownEnter"
        />
        <span v-if="inputText.length > 0" class="absolute bottom-1.5 right-2 text-[10px]" :class="isOverLimit ? 'text-light-fg-danger' : 'text-light-fg-muted'">
          {{ inputText.length }}/{{ MAX_LENGTH }}
        </span>
      </div>
      <button
        aria-label="Send message"
        class="flex h-[34px] w-9 shrink-0 items-center justify-center rounded-lg bg-light-fg-accent text-white transition-opacity disabled:opacity-30"
        type="button"
        :disabled="!canSubmit"
        @click="handleSubmit"
      >
        <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2L7 9M14 2L9.5 14L7 9M14 2L2 6.5L7 9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  disabled?: boolean;
  placeholder?: string;
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  placeholder: 'Type your message...',
});

const emit = defineEmits<{
  submit: [text: string];
}>();

const MAX_LENGTH = 500;

const inputText = ref('');
const textareaRef = ref<HTMLTextAreaElement>();

const isOverLimit = computed(() => inputText.value.length >= MAX_LENGTH);
const canSubmit = computed(() => inputText.value.trim().length > 0 && !isOverLimit.value);

const autoResize = () => {
  const textarea = textareaRef.value;
  if (!textarea) return;
  textarea.style.height = 'auto';
  textarea.style.height = `${Math.min(textarea.scrollHeight, 120)}px`;
};

const handleSubmit = () => {
  if (!canSubmit.value) return;
  emit('submit', inputText.value.trim());
  inputText.value = '';
  nextTick(() => autoResize());
};

const handleKeydownEnter = (event: KeyboardEvent) => {
  if (event.isComposing) return;
  handleSubmit();
};
</script>
